import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Sidebar = ({ collapsed = false, onToggleCollapse = () => {} }) => {
  const { hasRole } = useAuth();

  const navItems = [
    { path: '/dashboard', label: 'My Dashboard', icon: '📊', roles: [], end: true },
    { path: '/dashboard/team', label: 'Team Dashboard', icon: '📈', roles: ['Manager', 'Admin', 'Executive'] },
    { path: '/tasks', label: 'All Tasks', icon: '📋', roles: [] },
    { path: '/status', label: 'Submit Status', icon: '✍️', roles: [] },
    { path: '/inactive-tasks', label: 'Inactive Tasks', icon: '📌', roles: [] },
    { path: '/team', label: 'Team Statuses', icon: '👥', roles: ['Manager', 'Admin', 'Executive'] },
    { path: '/my-status', label: 'My Status Updates', icon: '📝', roles: [] },
    // { path: '/my-team', label: 'My Team', icon: '👨‍👩‍👧‍👦', roles: ['Manager', 'Admin'] },
    { path: '/announcements', label: 'Announcements', icon: '📢', roles: [] },
    { path: '/reports/weekly', label: 'Weekly Report', icon: '🗓️', roles: ['Manager', 'Executive',  'Admin'] },
  ];

  return (
    <aside
      className={`fixed top-16 left-0 z-30 h-[calc(100vh-4rem)] overflow-y-auto bg-white border-r border-gray-200 p-3 transition-all duration-200 ${
        collapsed ? 'w-20' : 'w-64'
      }`}
    >
      <div className={`mb-3 flex ${collapsed ? 'justify-center' : 'justify-end'}`}>
        <button
          type="button"
          onClick={onToggleCollapse}
          className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-gray-200 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary"
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="h-5 w-5"
          >
            {collapsed ? (
              <path d="M9 6l6 6-6 6" />
            ) : (
              <path d="M15 6l-6 6 6 6" />
            )}
          </svg>
        </button>
      </div>
      <nav className="space-y-2">
        {navItems.map((item) => {
          // Check if user has required role
          if (item.roles.length > 0 && !item.roles.some(role => hasRole(role))) {
            return null;
          }

          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              title={collapsed ? item.label : undefined}
              className={({ isActive }) =>
                `flex items-center ${collapsed ? 'justify-center' : 'gap-3'} px-3 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`
              }
            >
              <span className="text-xl">{item.icon}</span>
              {!collapsed && <span className="font-medium truncate">{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
